import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=0becc108&scoped=true&functional=true"
var script = {}
import style0 from "./Switcher.vue?vue&type=style&index=0&id=0becc108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0becc108",
  null
  
)

export default component.exports